import { styled } from '@mui/material';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import MuiButton from '@mui/material/Button';

import { colors, devices } from 'styles';

export const ModalContent = styled(Box)`
  width: calc(100% - 32px);
  max-width: 736px;
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  background: ${colors.white};
  border-radius: 12px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.24);
  outline: none;
`;

export const FormControlContainer = styled(Box)`
  display: flex;
  flex-direction: column;

  @media (${devices.sm}) {
    margin-top: 24px;
    align-items: center;
    flex-direction: row;
    flex-basis: 500px;
  }

  @media (${devices.md}) {
    margin-top: 8px;
  }
`;

export const EmailInputContainer = styled(Box)`
  width: 100%;
  min-width: 0;
`;
export const EmailInput = styled(TextField)`
  border-radius: 4px;
  background: ${colors.white};
`;

export const Button = styled(MuiButton)`
  width: 100%;

  &.Mui-disabled {
    background: ${colors.mainGray} !important;
  }

  @media (${devices.sm}) {
    width: 220px;
  }

  @media (${devices.md}) {
    width: 202px;
  }

  @media (${devices.lg}) {
    width: 222px;
  }

  &.MuiButtonBase-root {
    height: 56px;
    padding: 8px;
    box-sizing: border-box;
    background: ${colors.blue};
    color: ${colors.white};
  }
`;
